import posthog from 'posthog-js';

import { UserProperties } from './events/user';
import {
  OM_EVENTS,
  OMAnalysisStartedProperties,
  OMAnalysisCompletedProperties,
  OMFieldCorrectedProperties,
  OMAnalysisErrorProperties,
  OMAddedProperties,
} from './events/om-analyzer';
import { PROPERTY_EVENTS, PropertyDeleteProperties } from './events/property';
import {
  AUTH_EVENTS,
  AuthLoginProperties,
  AuthLogoutProperties,
  AuthLoginFailedProperties,
  AuthSignupProperties,
  AuthPasswordResetProperties,
} from './events/auth';

// Analytics Helper Functions
export const Analytics = {
  // Identify user and set their properties
  identifyUser: (userId: string, properties: Partial<UserProperties>) => {
    posthog.identify(userId, properties);
  },

  // Auth Events
  trackLogin: (properties: AuthLoginProperties) => {
    posthog.capture(AUTH_EVENTS.LOGIN, properties);
  },

  trackLogout: (properties: AuthLogoutProperties) => {
    posthog.capture(AUTH_EVENTS.LOGOUT, properties);
  },

  trackLoginFailed: (properties: AuthLoginFailedProperties) => {
    posthog.capture(AUTH_EVENTS.LOGIN_FAILED, properties);
  },

  trackSignup: (properties: AuthSignupProperties) => {
    posthog.capture(AUTH_EVENTS.SIGNUP, properties);
  },

  trackPasswordReset: (properties: AuthPasswordResetProperties) => {
    posthog.capture(AUTH_EVENTS.PASSWORD_RESET_REQUESTED, properties);
  },

  // OM Analysis Events
  trackOMAnalysisStarted: (properties: OMAnalysisStartedProperties) => {
    posthog.capture(OM_EVENTS.ANALYSIS_STARTED, properties);
  },

  trackOMAnalysisCompleted: (properties: OMAnalysisCompletedProperties) => {
    posthog.capture(OM_EVENTS.ANALYSIS_COMPLETED, properties);
  },

  trackOMFieldCorrected: (properties: OMFieldCorrectedProperties) => {
    posthog.capture(OM_EVENTS.FIELD_CORRECTED, properties);
  },

  trackOMAnalysisError: (properties: OMAnalysisErrorProperties) => {
    posthog.capture(OM_EVENTS.ANALYSIS_ERROR, properties);
  },

  trackOMAdded: (properties: OMAddedProperties) => {
    posthog.capture(OM_EVENTS.OM_ADDED, properties);
  },

  // Property Events
  trackPropertyDelete: (properties: PropertyDeleteProperties) => {
    posthog.capture(PROPERTY_EVENTS.DELETE, properties);
  },

  // Reset user
  reset: () => {
    posthog.reset();
  },
};

export default Analytics;
